import * as React from 'react';
import {ReactComponent as WhatsAppIcon} from '../assets/icon-whatsapp.svg';

type Props = {
    className?: string;
};
export const FloatingWhatsButton = (props: Props) => {
    return (
        <a
            href="https://api.whatsapp.com/send?phone=555434439053&text=Ol%C3%A1,%20estou%20na%20contrata%C3%A7%C3%A3o%20do%20Conecta%20Venda,%20preciso%20de%20ajuda.%20"
            target="_blank"
            rel="noopener noreferrer"
            id="whats_flutuante"
            aria-label="Falar com o atendimento pelo WhatsApp"
            className={`fixed z-50 w-14 md:w-16 h-14 md:h-16 flex items-center justify-center right-6 bottom-8 rounded-full bg-border hover:transform hover:scale-105 transition-transform duration-300 shadow-lg ${props.className} drop-shadow-[0px_4px_20px_rgba(0,0,0,0.25)] backdrop-blur-[2.5px]`}
        >
            <WhatsAppIcon className="w-16" aria-hidden="true"/>
        </a>
    )
};